import { createContext, useContext, useState, useEffect, useMemo } from "react";
import { fetchMenus } from "../api/menuApi";

const MenuContext = createContext(null);

export function MenuProvider({ children }) {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchMenus()
      .then((data) => {
        if (!cancelled) setMenus(data || []);
      })
      .catch((err) => console.error("Menu fetch failed", err))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const mainMenus = useMemo(
    () =>
      menus
        .filter((m) => m.position === "Main Menu" && m.isRoot && m.isActive !== false)
        .sort((a, b) => a.sequence - b.sequence),
    [menus],
  );

  const profileMenus = useMemo(
    () =>
      menus
        .filter((m) => m.position === "Profile Menu" && m.isRoot && m.isActive !== false)
        .sort((a, b) => a.sequence - b.sequence),
    [menus],
  );

  return (
    <MenuContext.Provider value={{ menus, mainMenus, profileMenus, loading }}>
      {children}
    </MenuContext.Provider>
  );
}

export function useMenu() {
  const ctx = useContext(MenuContext);
  if (!ctx) throw new Error("useMenu must be used within MenuProvider");
  return ctx;
}


